import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  Box,
  CircularProgress,
  Typography
} from '@mui/material';

function ProtectedRoute({ children }) {
  const { user, loading, logout } = useAuth();

  const [checkingAccess, setCheckingAccess] = useState(true);
  const [accessAllowed, setAccessAllowed] = useState(false);
  const [accessError, setAccessError] = useState(false);

  useEffect(() => {
    const checkPartnerAccess = async () => {
      // Ainda não sabemos se existe utilizador
      if (loading) {
        return;
      }

      // Não está autenticado
      if (!user) {
        setCheckingAccess(false);
        setAccessAllowed(false);
        return;
      }

      try {
        setCheckingAccess(true);
        setAccessError(false);

        const response = await fetch(
          `https://api.hub4food.colab4food.com/api/partner-access/${user.userId}`
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.error || 'Erro ao verificar acesso'
          );
        }

        /*
         * O backend deve devolver:
         *
         * Utilizador normal Hub4Food:
         * access_allowed: true
         *
         * Utilizador Colab4Food com pagamento:
         * access_allowed: true
         *
         * Utilizador Colab4Food sem pagamento:
         * access_allowed: false
         */

        if (data.access_allowed === true) {
          setAccessAllowed(true);
          return;
        }

        // Subscrição cancelada/expirada
        setAccessAllowed(false);

        // Remove também o user do localStorage
        logout();

      } catch (error) {
        console.error(
          'Erro ao verificar acesso do utilizador:',
          error
        );

        setAccessAllowed(false);
        setAccessError(true);

      } finally {
        setCheckingAccess(false);
      }
    };

    checkPartnerAccess();

  }, [user?.userId, loading]);

  // AuthContext ainda está a carregar localStorage
  if (loading || checkingAccess) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh'
        }}
      >
        <CircularProgress size={60} />

        <Typography variant="h6" sx={{ mt: 2 }}>
          A verificar acesso...
        </Typography>
      </Box>
    );
  }

  // Não existe login
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Não foi possível consultar o backend
  if (accessError) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh'
        }}
      >
        <Typography variant="h6">
          Não foi possível verificar o acesso à plataforma.
        </Typography>
      </Box>
    );
  }

  // Sem subscrição/acesso
  if (!accessAllowed) {
    return <Navigate to="/" replace />;
  }

  // Tudo válido
  return children;
}

export default ProtectedRoute;